import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';
import {
  RECOMMENDATION_TYPES,
} from '@bingads-webui-campaign/recommendation-core';

export const AdditionalPitching = props => (
  <div>
    {props.additionDetailPitchingConfig[props.type] &&
      <div>
        {props.i18n.getString(props.additionDetailPitchingConfig[props.type].detailPitching)}
      </div>
    }
    {props.needNRTDisclaimer &&
      <div className="detail-summary-additional-pitching">
        {props.i18n.getString(`Details_View_NRT_Disclaimer_${props.type}`) || props.i18n.getString('Details_View_NRT_Disclaimer')}
      </div>
    }
    {props.inProductUpdateConfig &&
      props.isDefinedAdditionalPitching &&
      props.isRSARecAutoApplyNotOptIn &&
      <div className="detail-summary-additional-pitching">
        {props.i18n.getString(props.inProductUpdateConfig.additionalPitching)}
      </div>
    }
    {props.type === RECOMMENDATION_TYPES.SSC_2_PMAX_MIGRATION &&
      <div>
        {props.newI18n.getString(_TL_('Expand your ad reach and drive your performance by upgrading your smart shopping campaigns to Performance Max campaigns. We\'ll use your existing assets, settings, and budgets to create new Performance Max campaigns while maintaining performance insights from previous campaigns. This update usually takes about one day to complete.'))}
      </div>
    }
    {props.permissions.IsAccountEnabledForCrawlImagesFromLandingPage &&
    props.type === RECOMMENDATION_TYPES.IMAGE_EXTENSION &&
    <div>
      <div>
        {props.newI18n.getString(_TL_('Turning on the auto-retrieve image tool allows your ads to use images from your website, and you agree that all images belong to you under the'))}
        <span>&nbsp;</span>
        <a href="https://about.ads.microsoft.com/en-us/resources/policies/microsoft-advertising-agreement" target="_apexPlatformHelp">
          {props.newI18n.getString(_TL_('Microsoft Advertising Agreement'))}
        </a>
        <span>.</span>
      </div>
      <div>
        {props.newI18n.getString(_TL_('You can change your image auto-retrieval settings anytime'))}
        <span>&nbsp;</span>
        <a
          href={`/campaign/vnext/accountsettings?cid=${props.cid}&aid=${props.aid}&uid=${props.uid}`}
        >
          {props.newI18n.getString(_TL_('here'))}
        </a>
        <span>.</span>
      </div>
    </div>
  }
  </div>
);

AdditionalPitching.propTypes = {
  additionDetailPitchingConfig: PropTypes.objectOf(PropTypes.any),
  aid: PropTypes.number,
  cid: PropTypes.number,
  i18n: PropTypes.PropTypes.shape({
    getString: PropTypes.func,
  }),
  inProductUpdateConfig: PropTypes.objectOf(PropTypes.any),
  isDefinedAdditionalPitching: PropTypes.bool,
  isRSARecAutoApplyNotOptIn: PropTypes.bool,
  needNRTDisclaimer: PropTypes.bool,
  newI18n: PropTypes.PropTypes.shape({
    getString: PropTypes.func,
  }),
  permissions: PropTypes.objectOf(PropTypes.any),
  type: PropTypes.string,
  uid: PropTypes.number,
};

AdditionalPitching.defaultProps = {
  additionDetailPitchingConfig: {},
  aid: null,
  cid: null,
  i18n: {
    getString: _.noop,
  },
  inProductUpdateConfig: {},
  isDefinedAdditionalPitching: false,
  isRSARecAutoApplyNotOptIn: false,
  needNRTDisclaimer: false,
  newI18n: {
    getString: _.noop,
  },
  permissions: {},
  type: null,
  uid: null,
};
